<template>
  <main class="sa-content">
    <div v-if="loading">
      <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
    </div>
    <div v-else>
      <div class="sa-card-large">
        
        <doctor-details :d="details" />
        <!-- <div class="sa-row sa-mt20">
          <div
            v-if="(userInfo.utid == '1' || userInfo.utid == '2') && (details && details.status == '3' || details && details.status == '4' || details && details.status == '7' ||details && details.status == '9')"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
            <add-treatment-details :d="details" />
          </div>
        </div>-->
      </div>
    </div>
  </main>
</template>
<script>
// import AddTreatMentDetVue from "../../components/appointments/AddTreatMentDet.vue";
import DoctorDetailsVue from "../../components/appointments/DoctorDetails.vue";
import { pro_url } from "../../../config/endpoints";
export default {
  components: {
    // "add-treatment-details": AddTreatMentDetVue,
    "doctor-details": DoctorDetailsVue,
  },
  data() {
    return {
      details: null,
      userInfo: {},
      loading: false,
      app_stat: "3"
    };
  },
  created() {
    let _self = this;
    let aid = this.$route.params.appid;
    _self.getData(aid);
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
  },
  methods: {
    getData(aid) {
      let _self = this;
      _self.loading = true;
      let wobj = {};
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/apt/${aid}`,
          query: wobj
        })
        .then(response => {
          if (response && response.status === 1000) {
              if(response.data && response.data.previous_appnt){
              response.data.previous_appnt.general_details.pregnency_status = (response.data.previous_appnt.general_details.pregnency_status == true)?'Yes' : 'No'
            }
            _self.details = response.data;
            let patDetails = {
              apnt_id: _self.details.apnt_id,
              pid: _self.details.pid,
              sanar_uid: _self.details.sanar_uid
            }
            _self.$localStorage.set('patDetails', JSON.stringify(patDetails))
            _self.app_stat = _self.details.status;
            if (_self.details.status == "7" || _self.details.status == "9") {
              _self.app_stat = "3";
            }
            _self.loading = false;
          } else {
          }
        })
        .catch(e => {
         // console.log(e);
        });
    }
  }
};
</script>
